import React from "react";
import { Star, Quote } from "lucide-react";
import { SectionHeader } from "./Rates";
import { REVIEWS } from "../mock";

const Reviews = () => {
  return (
    <section id="reviews" className="relative py-24 grid-bg">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <SectionHeader eyebrow="What Our Members Say" title="Google Reviews" sub="Real words from our trusted community of investors & coin buyers across Nagpur." />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <div key={i} className="border border-white/8 bg-white/[0.02] p-8 card-glow relative">
              <Quote className="absolute top-6 right-6 text-gold/15" size={40} />
              <div className="flex gap-1 text-gold">
                {Array.from({ length: r.rating }).map((_, j) => <Star key={j} size={16} fill="#d4af37" strokeWidth={0} />)}
              </div>
              <p className="font-body text-gray-300 mt-4 leading-relaxed italic">“{r.text}”</p>
              <div className="flex items-center gap-3 mt-6">
                <div className="h-11 w-11 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center font-display text-lg text-gold">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <p className="font-display text-lg text-white leading-tight">{r.name}</p>
                  <p className="font-ui text-[10px] tracking-wider uppercase text-muted-foreground">Verified · Google Review</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
